import { Form, Select } from 'antd';
import type { FormItemProps } from 'antd/es/form';

import type { Emoji } from 'app/components/pages/QuickFilters/types';
import { useAppSelector } from 'app/redux/hooks';
import { selectEmojis } from 'app/redux/selectors/pictures';

import { PictureComponent } from '../PictureComponent/PictureComponent';

const { Option } = Select;

type Props<T> = {
  formProps: FormItemProps<T>;
};

export const EmojiFormSelect = <T,>({ formProps }: Props<T>) => {
  const emojis: Emoji[] = useAppSelector(selectEmojis);

  const filterOption = (
    input: string,
    option?: { label: string; value: string }
  ) => (option?.label ?? '').toLowerCase().includes(input.toLowerCase());

  return (
    <Form.Item {...formProps}>
      <Select
        placeholder="Select an emoji"
        showSearch
        filterOption={filterOption}
      >
        {emojis.map((emoji: Emoji) => (
          <Option key={emoji.id} value={emoji.id} label={emoji.name}>
            <PictureComponent pictureId={emoji.pictureId} width={16} />
            <span
              className="emoji-option"
              style={{ textTransform: 'capitalize' }}
            >
              {emoji.name}
            </span>
          </Option>
        ))}
      </Select>
    </Form.Item>
  );
};
